(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('add-condition', {
            parent: 'entity',
            url: '/add-condition?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addCondition.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-condition/add-conditions.html',
                    controller: 'AddConditionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addCondition');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('add-condition-detail', {
            parent: 'entity',
            url: '/add-condition/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addCondition.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-condition/add-condition-detail.html',
                    controller: 'AddConditionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addCondition');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AddCondition', function($stateParams, AddCondition) {
                    return AddCondition.get({id : $stateParams.id});
                }]
            }
        })
        .state('add-condition.new', {
            parent: 'add-condition',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-condition/add-condition-dialog.html',
                    controller: 'AddConditionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                information: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('add-condition', null, { reload: true });
                }, function() {
                    $state.go('add-condition');
                });
            }]
        })
        .state('add-condition.edit', {
            parent: 'add-condition',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-condition/add-condition-dialog.html',
                    controller: 'AddConditionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AddCondition', function(AddCondition) {
                            return AddCondition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-condition', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('add-condition.delete', {
            parent: 'add-condition',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-condition/add-condition-delete-dialog.html',
                    controller: 'AddConditionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AddCondition', function(AddCondition) {
                            return AddCondition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-condition', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
